import React from "react";

const ViewCommonAction = ({ onClick }) => {
  return (
    <button type="button" className="btn btn-circle" onClick={() => onClick()}>
      <i className="mdi mdi-eye-outline text-primary h5"></i>
    </button>
  );
};

export default ViewCommonAction;
